<template>
    <div>
        <div class="banner">
            <div class="headerReplacementDebtInfo"></div>
            <div class="banner-text">
                <b>อันดับความน่าเชื่อถือ</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span>ข้อมูลตราสารหนี้</span>
                    <span class="separator"></span>
                    <span><b>อันดับความน่าเชื่อถือ</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="TabMenu">
                <DebtInfoTabMenu />
            </div>

            <table class="table mt-3 mb-5">
                <thead>
                    <tr class="table-secondary text-center">
                        <th scope="col"><b>วันที่</b></th>
                        <th scope="col"><b>อันดับเครดิตองค์กร</b></th>
                        <th scope="col"><b>ดาวน์โหลด</b></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row" class="text-center">23 เมษายน 2567</th>
                        <td class="text-center">BBB+ / Stable</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904073665-1.%2023-04-2567(BBB+%20:%20Stable).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">24 เมษายน 2566</th>
                        <td class="text-center">BBB+ / Stable</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904119958-2. 24-04-2566(BBB+ : Stable).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">24 มีนาคม 2565</th>
                        <td class="text-center">BBB+ / Stable</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904137036-3. 24-03-2565(BBB+ : Stable).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">30 เมษายน 2564</th>
                        <td class="text-center">BBB / Positive</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904177252-4. 30-04-2564(BBB : Positive).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">29 เมษายน 2563</th>
                        <td class="text-center">BBB / Stable</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904203663-5. 29-04-2563(BBB : Stable).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">05 เมษายน 2562</th>
                        <td class="text-center">BBB / Stable</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904232150-6. 05-04-2562(BBB : Stable).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">03 สิงหาคม 2561</th>
                        <td class="text-center">BBB- / Positive</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904262457-7. 03-08-2561(BBB-:Positive).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">29 กันยายน 2560</th>
                        <td class="text-center">BBB- / Stable</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904285761-8. 29-09-2560(BBB-:Stable).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">23 พฤษภาคม 2560</th>
                        <td class="text-center">BBB- / Developing</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904311269-9. 23-05-2560(BBB-:Developing).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">17 เมษายน 2560</th>
                        <td class="text-center">BBB- / Stable</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904329688-10. 17-04-2560(BBB-:Stable).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-center">12 กันยายน 2559</th>
                        <td class="text-center">BBB- / Stable</td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738904352669-11. 12-07-2559(BBB-:Stable).pdf" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
  
<script>
import DebtInfoTabMenu from '@/components/DebtInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        DebtInfoTabMenu,
    },
    data() {
        return {
            financialData: null,
        };
    },
    methods: {
        async init() {
            let response = await store.dispatch(GET_FINANCIAL_DATA);
            if (response) {
                this.financialData = response; // Assign fetched data to local state
            } else {
                console.error('Failed to fetch financial data');
            }
        },
    },

};
</script>
<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  